module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/184-sweden-4c87c097c1f5a24cf4c0ce7fe0a635f9.svg";